/** Completeness of a builder company profile. Mirrored in the company-profile-builder edge function. */
export interface CompletenessItem { key: string; label: string; screen: number }

const has = (v: unknown) => (Array.isArray(v) ? v.length > 0 : typeof v === "string" && v.trim().length > 0);

export const TICKET_BANDS = ["Under ₹50k", "₹50k – 2 lakh", "₹2 – 10 lakh", "₹10 – 50 lakh", "₹50 lakh – 1 crore", "Above ₹1 crore", "Not sure"];

/** Every named product has a ticket size; old profiles fall back to the single deal size. */
export function ticketsOk(f: any, g: any): boolean {
  const ps = Array.isArray(f?.products) ? f.products.filter((p: any) => has(p?.name)) : [];
  if (ps.length && ps.every((p: any) => has(p?.ticket_size))) return true;
  return has(f?.typical_deal_size) || has(g?.deal_size);
}

export const COMPLETENESS_ITEMS: (CompletenessItem & { ok: (f: any, g: any) => boolean })[] = [
  { key: "summary", label: "what you do", screen: 0, ok: (f) => has(f?.summary) },
  { key: "products", label: "products", screen: 1, ok: (f) => has(f?.products) },
  { key: "industries", label: "industries", screen: 2, ok: (f) => has(f?.industries_served) },
  { key: "buyers", label: "buyer job titles", screen: 2, ok: (f, g) => has(f?.buyer_titles) || has(g?.buyer_titles) },
  { key: "regions", label: "where you serve", screen: 3, ok: (f, g) => has(f?.supply_regions) || has(f?.locations) || has(g?.supply_regions) },
  { key: "clients", label: "client names", screen: 4, ok: (f, g) => has(f?.client_names) || has(g?.best_customers) },
  { key: "proof", label: "achievements or certifications", screen: 4, ok: (f) => has(f?.proof_points) || has(f?.certifications) },
  { key: "deal", label: "ticket size for each product", screen: 1, ok: (f, g) => ticketsOk(f, g) },
];

export function profileCompleteness(facts: any, gaps: any): { score: number; missing: CompletenessItem[] } {
  const missing = COMPLETENESS_ITEMS.filter((i) => !i.ok(facts, gaps)).map(({ key, label, screen }) => ({ key, label, screen }));
  return { score: Math.round(((COMPLETENESS_ITEMS.length - missing.length) / COMPLETENESS_ITEMS.length) * 100), missing };
}

/** Turn "www.wdcweb.com" into "Wdcweb" when no company name was found. */
export function nameFromWebsite(url: string): string {
  const host = url.trim().replace(/^https?:\/\//i, "").replace(/^www\./i, "").split(/[/?#]/)[0];
  const base = host.split(".")[0] ?? "";
  return base ? base.charAt(0).toUpperCase() + base.slice(1) : "";
}
